module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    ref: "combinationcontainer",
    staticClass: "combination-container common-container"
  }, [_c('section', {
    staticClass: "data-oper"
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editData
    }
  }, [_vm._v("添加")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "data-content",
    attrs: {
      "data": _vm.datas,
      "stripe": true,
      "height": _vm.containerHeight - 85,
      "highlight-current-row": "",
      "id": "out-table",
      "border": "",
      "row-key": "id"
    },
    on: {
      "cell-click": _vm.cellClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "type": "index",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.pageNum - 1) * _vm.pageSize + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "视频名称",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "url",
      "label": "视频",
      "align": "center",
      "min-width": "20%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!!scope.row.url),
            expression: "!!scope.row.url"
          }],
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "点击查看视频",
            "placement": "top"
          }
        }, [_c('video', {
          staticStyle: {
            "width": "50px",
            "height": "50px"
          },
          attrs: {
            "src": scope.row.url
          }
        })])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "thumimage",
      "label": "图片",
      "align": "center",
      "min-width": "20%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-image', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!!scope.row.thumimage),
            expression: "!!scope.row.thumimage"
          }],
          staticStyle: {
            "width": "50px",
            "height": "50px"
          },
          attrs: {
            "src": scope.row.thumimage,
            "fit": "cover"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "留言",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "状态",
      "formatter": _vm.formatStatus,
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.delData(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")]), _vm._v("|\n\t\t\t\t\t"), _c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.enableData(scope.$index, scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.status === "0" ? '禁用' : '启用'))]), _vm._v("|\n\t\t\t\t\t"), _c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.editData(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")])]
      }
    }])
  })], 1), _vm._v(" "), _c('pagination', {
    attrs: {
      "pageSize": _vm.pageSize,
      "pageNum": _vm.pageNum,
      "totalNum": _vm.totalNum
    },
    on: {
      "handlePageSizeChange": _vm.handlePageSizeChange,
      "handlePageCurrentChange": _vm.handlePageCurrentChange
    }
  }), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-container",
    attrs: {
      "title": _vm.dialogTitle + '数据',
      "visible": _vm.editDialogVisible,
      "width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialogVisible = $event
      },
      "opened": _vm.openDialog
    }
  }, [_c('el-form', {
    ref: "formData",
    staticClass: "form-data",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.rules,
      "label-width": "100px",
      "size": "mini"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "视频名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "id": "focus-ele"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "视    频",
      "prop": ""
    }
  }, [_c('UploadFileVideo', {
    ref: "UploadFileVideo",
    attrs: {
      "videoUrl": _vm.formData.url
    },
    on: {
      "getVideoUrl": _vm.getVideoUrl
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "图    片",
      "prop": ""
    }
  }, [_c('UploadFile', {
    ref: "UploadFile",
    attrs: {
      "imgUrl": _vm.formData.thumimage
    },
    on: {
      "getFileUrl": _vm.getFileUrl
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "留    言",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "type": "textarea",
      "rows": 4,
      "maxlength": "100"
    },
    model: {
      value: (_vm.formData.remark),
      callback: function($$v) {
        _vm.$set(_vm.formData, "remark", $$v)
      },
      expression: "formData.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "hzpbtn-close",
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("关 闭")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('formData')
      }
    }
  }, [_vm._v("保 存")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-container",
    attrs: {
      "title": _vm.videoDialogTitle,
      "visible": _vm.videoDialogVisible,
      "width": "600px",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.videoDialogVisible = $event
      }
    }
  }, [_c('section', {
    staticStyle: {
      "width": "90%",
      "margin": "10px auto"
    }
  }, [_c('video', {
    staticStyle: {
      "width": "100%",
      "height": "304px",
      "margin-bottom": "10px"
    },
    attrs: {
      "id": "videoSec",
      "src": _vm.videoUrl,
      "controls": "controls"
    }
  }, [_vm._v("\n\t\t\t\t\tYour browser does not support the video tag.\n\t\t\t\t")]), _vm._v(" "), _c('section', [_c('strong', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("留言：")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "15px"
    }
  }, [_vm._v(_vm._s(_vm.videoRemark))])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-497d2ed9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/bannerManagement/Video.vue
// module id = 705
// module chunks = 1